import React, { useEffect } from 'react';

const MACHINE_GATEWAY_URL = 'https://rapidfusionfleet.co.uk/';

const MachineGateway = () => {
  useEffect(() => {
    window.location.href = MACHINE_GATEWAY_URL;
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <p>Redirecting to Machine Gateway...</p>
    </div>
  );
};

export default MachineGateway;
